import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react'

import { tokenStorage } from '@/shared/api/tokenStorage'
import { AuthContext } from '@/shared/auth/AuthContext'
import { authApi } from '@/shared/auth/authApi'
import type { User } from '@/shared/auth/types'

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  // Sessão é o token guardado (ADR 0008, stateless): na carga tentamos hidratar
  // o usuário a partir dele; se falhar, o token não vale mais.
  useEffect(() => {
    if (!tokenStorage.access) {
      setLoading(false)
      return
    }
    authApi
      .me()
      .then(setUser)
      .catch(() => tokenStorage.clear())
      .finally(() => setLoading(false))
  }, [])

  const login = useCallback(async (email: string, password: string) => {
    const tokens = await authApi.obtainToken(email, password)
    tokenStorage.save(tokens)
    setUser(await authApi.me())
  }, [])

  const logout = useCallback(() => {
    tokenStorage.clear()
    setUser(null)
  }, [])

  const value = useMemo(() => ({ user, loading, login, logout }), [user, loading, login, logout])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
